import React from "react";
import { connect } from "react-redux";

import { Game } from "../models/Game";
import { set404Status } from "../store/reducers";
import { P404Template } from "../templates/p404/p404";

type P404Props = {
  games: Game[];
  dispatch?: any;
};

interface RootState {
  games: Game[];
}

class Page extends React.PureComponent<P404Props> {
  render() {
    this.props.dispatch(set404Status(true));

    return <P404Template games={this.props.games} />;
  }
}

export const P404Page = connect((state: RootState) => ({
  games: state.games,
}))(Page);
